export default "__VITE_ASSET__BrUtHail__"